// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import BaiduMap from 'vue-baidu-map'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import wow from 'wowjs'
import i18n from './i18n/i18n.js'
import 'babel-polyfill'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Api from './base/js/api.js'
import MetaInfo from 'vue-meta-info'
import VueAnimateNumber from 'vue-animate-number'


Vue.prototype.$api = Api
Vue.prototype.$wow=wow

//style
import 'element-ui/lib/theme-chalk/index.css'
import 'swiper/css/swiper.css'
import './base/styles/iconfont.css'
import 'animate.css/source/animate.css'

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(VueAwesomeSwiper)
Vue.use(BaiduMap,{
	ak: 'gmnfu76oPVMBXGVvOWhcAoO9Q56VaV9c'
})
// Vue.prototype.$http = axios
Vue.use(VueAxios,axios)
Vue.use(MetaInfo)
Vue.use(VueAnimateNumber)

var AppLang = sessionStorage.getItem('locale')
Vue.prototype.$AppLang = AppLang


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
	i18n,
  components: { App },
  template: '<App/>'
})

router.afterEach((to,from,next) => {
    window.scrollTo(0,0);
});



// WEBPACK FOOTER //
// ./src/main.js